import React from "react";
import { Navigate, useLocation } from "react-router";
import { useAppSelecter } from "../../../hooks/storeHooks";
import { ObjectValues } from "../../../pages/login";
import { SidebarContent } from "./staticContents";

export interface onlyChildProps {
  children: React.ReactElement<any, any> | null;
}

const ModuleAccess: React.FC<onlyChildProps> = ({ children }) => {
  const location = useLocation();
  const userSlice = useAppSelecter(
    (state: ObjectValues) => state.userSlice.loggedUser
  );
  const currentModule = SidebarContent.list.find(
    (s) => s.path === location.pathname
  );

  return userSlice &&
    userSlice.module &&
    userSlice.module.length > 0 &&
    currentModule ? (
    userSlice.module.includes(currentModule.access) ? (
      children
    ) : SidebarContent.list.find((s) => userSlice.module.includes(s.access)) ? (
      <Navigate
        to={
          SidebarContent.list.find((s) => userSlice.module.includes(s.access))
            ?.path ?? "/"
        }
        replace
        state={{ destinationPathname: location.pathname }}
      />
    ) : (
      <Navigate
        to={"/"}
        replace
        state={{ destinationPathname: location.pathname }}
      />
    )
  ) : (
    children
  );
};

export default ModuleAccess;
